const categories = [
    {
        id: 1,
        category: 'Accessories',
    },
    {
        id: 2,
        category: 'Camera',
    },
    {
        id: 3,
        category: 'Home Appliances',
    },
    {
        id: 4,
        category: 'Kitchen Appliances',
    },
    {
        id: 5,
        category: 'Laptops',
    },
    {
        id: 6,
        category: 'Mobiles & Tablets',
    },
    {
        id: 7,
        category: 'Televisions',
    },
    {
        id: 8,
        category: 'Washing Machines',
    },
]

export default categories;
